import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import DeviationDumbView from '../../../../Dumbo';
import DeviationThumbOverlayDefault from '../../../legos/DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../../../legos/DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../../../legos/ThumbOverlayBackground';
import ThumbLink from '../../../legos/ThumbLink';
import { useDeviationMatureFilter } from '../../../../../utils/hooks/useDeviationMatureFilter';
import { getDeviationOwner } from '../../../../../utils/adoptables';
import { getIsMatureBlock } from '../../../../../Moderation/redux/selectors';
import { OWNER_AVATAR_SIZE } from '../../../../../ShopCard/_partials/ShopCardDumb/ShopCardDumb';
import UserAvatar from '../../../../../User/Avatar/UserAvatar';
import UserLink from '../../../../../User/Link';
import s from './MobileThumbContent.scss';
const MobileThumbContent = ({ deviation, width, height, responsive, className, reducedOverlayPadding, masonryHeightCalc, dumboClassName })=>{
    const { t } = useTranslation();
    const { displayReason: blockReason } = useDeviationMatureFilter(deviation);
    const isMatureBlock = getIsMatureBlock(blockReason);
    const owner = getDeviationOwner(deviation);
    return /*#__PURE__*/ React.createElement(ThumbLink, {
        deviation: deviation,
        width: width,
        height: height,
        wrapperClassName: classnames(s['root'], isMatureBlock && s['mature-block'], className)
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive,
        masonryHeightCalc: masonryHeightCalc,
        className: dumboClassName,
        withSeoData: true,
        // We'll rely on the link to inform screen readers
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement(ThumbOverlayBackground, {
        deviation: deviation,
        className: s['underlay'],
        showDefaultHover: true
    }), /*#__PURE__*/ React.createElement(DeviationThumbOverlayDefault, {
        deviation: deviation,
        width: width,
        height: height,
        className: classnames(s['cover'], reducedOverlayPadding && s['cover-reduced-padding'])
    }, owner && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['owner-overlay'], reducedOverlayPadding && s['owner-reduced-padding'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['owner-details']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: owner,
        size: OWNER_AVATAR_SIZE
    }), t('deviationview.overlay.adoptable.ownedBy'), /*#__PURE__*/ React.createElement(UserLink, {
        user: owner,
        className: s['owner-link']
    })))), /*#__PURE__*/ React.createElement(DeviationThumbMiddleContent, {
        deviation: deviation,
        thumbWidth: width,
        thumbHeight: height,
        className: s['middle'],
        isMatureBlock: isMatureBlock
    }));
};
MobileThumbContent.displayName = 'MobileThumbContent';
export default MobileThumbContent;

//# sourceMappingURL=MobileThumbContent.js.map